module.exports = __webpack_public_path__ + "static/full04-3e06c7660b060d6266eb0aa8bb2f17bc.png";